export default __webpack_public_path__ + "static/media/025-businessman.24612994.svg";